import React from "react";
// import GoogleDriveAccess from "./googleDriveAccess";
import GoogleDriveAccess from "./components/Drive/GoogleDriveAccess";

function App() {
    return (
        <div className="App">
            <GoogleDriveAccess />
        </div>
    );
}

export default App;


